import React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import store from './app-state/store';
import AppIndex from './AppIndex';
import * as ga from './canopy-ui-components/google-analytics';
import './i18n';
import reportWebVitals from './reportWebVitals';
import './styles/index.scss';
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <>
        <React.StrictMode>
            {/* <ErrorBoundary> */}
            <HelmetProvider>
                <Provider store={store}>
                    <AppIndex />
                </Provider>
            </HelmetProvider>
            {/* </ErrorBoundary> */}
        </React.StrictMode>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

ga.initialize();
